import React from 'react';
import DashboardPagination from '../DashboardPagination';
import { OfficialTableCell } from '../print/OfficialReportLayout';
import { RelatorioEmendaItem } from '../../services/reportService';
import { TipoEmendaDTO, resolveTipoEmendaNome } from '../../services/tipoEmendaService';
import { fMoney } from '../../utils/emendaFormatters';
import { Table, Tbody, Thead, Tr } from '../ui/Table';

const PAGE_SIZE_OPTIONS = [10, 20, 50];

const isDevolvida = (status?: string) => /devolvid/i.test(status ?? '');

const formatDate = (value?: string) => {
  if (!value) return 'Não informado';
  return new Intl.DateTimeFormat('pt-BR').format(new Date(`${value}T00:00:00`));
};

interface ReportRelacaoTableProps {
  items: RelatorioEmendaItem[];
  totalItems: number;
  page: number;
  size: number;
  onPageChange: (p: number) => void;
  onPageSizeChange: (s: number) => void;
  tipos: TipoEmendaDTO[];
}

const ReportRelacaoTable: React.FC<ReportRelacaoTableProps> = ({
  items,
  totalItems,
  page,
  size,
  onPageChange,
  onPageSizeChange,
  tipos,
}) => {
  if (items.length === 0) {
    return (
      <div className="rounded-xl border border-slate-200 px-4 py-10 text-center text-sm text-slate-500 dark:border-slate-700 dark:text-slate-400">
        Nenhuma emenda encontrada para os filtros informados.
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-2xl border border-slate-200 dark:border-slate-700">
      <div className="overflow-x-auto">
        <Table>
          <Thead>
            <Tr>
              <OfficialTableCell head>Código</OfficialTableCell>
              <OfficialTableCell head>Parlamentar</OfficialTableCell>
              <OfficialTableCell head>Instituição</OfficialTableCell>
              <OfficialTableCell head>Objeto</OfficialTableCell>
              <OfficialTableCell head>Secretaria</OfficialTableCell>
              <OfficialTableCell head>Etapa</OfficialTableCell>
              <OfficialTableCell head>Tipo</OfficialTableCell>
              <OfficialTableCell head align="center">Data</OfficialTableCell>
              <OfficialTableCell head align="right">Valor</OfficialTableCell>
            </Tr>
          </Thead>
          <Tbody>
            {items.map((item) => (
              <Tr key={item.id} className={isDevolvida(item.statusCicloVida) ? 'border-l-4 border-red-400 bg-red-50 dark:bg-red-950/20' : ''}>
                <OfficialTableCell>
                  <div className="font-semibold">{item.codigoOficial || 'Não informado'}</div>
                  <div className="text-[11px] text-slate-500 dark:text-slate-400">Exercício {item.exercicio || 'Não informado'}</div>
                </OfficialTableCell>
                <OfficialTableCell>{item.parlamentarNome || 'Não informado'}</OfficialTableCell>
                <OfficialTableCell>{item.instituicaoNome || 'Não informado'}</OfficialTableCell>
                <OfficialTableCell>{item.objeto || 'Não informado'}</OfficialTableCell>
                <OfficialTableCell>{item.secretariaDestino || 'Não informada'}</OfficialTableCell>
                <OfficialTableCell>{item.statusCicloVida || 'Não informado'}</OfficialTableCell>
                <OfficialTableCell>{resolveTipoEmendaNome(item.tipo, tipos)}</OfficialTableCell>
                <OfficialTableCell align="center">{formatDate(item.data)}</OfficialTableCell>
                <OfficialTableCell align="right">{fMoney(item.valor)}</OfficialTableCell>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </div>
      <DashboardPagination
        page={page}
        pageSize={size}
        totalItems={totalItems}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        pageSizeOptions={PAGE_SIZE_OPTIONS}
        itemLabel="emendas"
      />
    </div>
  );
};

export default ReportRelacaoTable;
